import React, { useState, useEffect, useMemo } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import Select from "react-select";
import { MdOutlineFileUpload } from "react-icons/md";
import redirectURL from "../../redirectURL"
import { utils, writeFile } from "xlsx";
import * as XLSX from "xlsx";
import dsStorescsv from "../../../assets/json/dsstores.csv";
import "./dsstores.css"
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { MdSync } from "react-icons/md";



const DarkStoresTab = () => {
  // const today = new Date().toISOString().split("T")[0];
  
  const today = new Date().toLocaleDateString("en-CA", { timeZone: "Asia/Kolkata" });

  const [currentDate, setCurrentDate] = useState(today);
  const [selectedStore, setSelectedStore] = useState({ label: "Gurgaon DS 1", value: "D009" });
  const [filteredData, setFilteredData] = useState([]);
  const [showAlert, setShowAlert] = useState(false);
  const [alertTitle, setAlertTitle] = useState("");
  const [alertType, setAlertType] = useState("info");
  const [isLoading, setIsLoading] = useState(false);
  const [overlay, setOverlay] = useState(false);
  const [highlightedDates, setHighlightedDates] = useState([]);
  const [currentinvoiceDate, setCurrentInvoiceDate] = useState(new Date())
  const [prevDate, setPrevDate] = useState([])
  const [isSliderOpen, setSliderOpen] = useState(false);
  const [sliderType, setSliderType] = useState(null); // or 0 if default is number
  const [sliderCl, setSliderCl] = useState("");
  const [sliderTitle, setSliderTitle] = useState("");
  const [uploadedFileData, setUploadedFileData] = useState([])
  const [currentUploadedDate, setCurrentUploadedDate] = useState(""); // or new Date() if it's a date object
  const [show, setShow] = useState(false);
  const [basicType, setBasicType] = useState(""); // "info" or "success"
  const [basicTitle, setBasicTitle] = useState(""); // alert title message
  const [loadshow, setLoadshow] = useState("show-n"); // "show-m" to show, "show-n" to hide
  const [overlayBlock, setOverlayBlock] = useState("show-n");
  const [overlyBlock, setOverlyBlock] = useState("show-n");
  const [file, setFile] = useState(null)
  const [selectedDs, setSelectedDs] = useState(null)
  const [darkStoreData, setDarkStoreData] = useState([])
  const [filename, setFilename] = useState("")
  const [darkStores, setDarkStores] = useState([])
  const [fetchedIds, setFetchedIds] = useState([])
    const [status, setStatus] = useState("");

  const [confirmPopup , setConfirmPopup] = useState(false); // New state for Yes/No popup

  const formatDate = (isoString) => {
    if (!isoString) return "";
    return isoString.split("T")[0]; // take only YYYY-MM-DD
  };


  const getDarkStoreData = async () => {
    const params = {};
    try {
      setLoadshow("show-m");
      setOverlayBlock("show-m");
      const response = await redirectURL.post(
        "inventory/getDarkStoresData",
        params
      );
      setLoadshow("show-n");
      setOverlayBlock("show-n");

      if (response.data.status === "success") {
        setSelectedStore({ label: response.data.store_name, value: response.data.store_id })
        setCurrentInvoiceDate(new Date(response.data.date))
        setDarkStoreData(response.data.data)
      } else {
      }

    } catch (error) {
      const errorMessage = error.response?.data?.message || "Failed to getting data";
      console.log({ errorMessage })
    }
  }

  const getDsFiltersData = async () => {
    try {
      setLoadshow("show-m");
      setOverlayBlock("show-m");
      const response = await redirectURL.post(
        "inventory/getDSFiltersData", {}
      );
      setLoadshow("show-n");
      setOverlayBlock("show-n");

      if (response.status  === 200) {
        var {dsData, dates, fetched_dark_store_ids} = response.data
        dsData = dsData.map((item) => ({ label: item.destination_store_name, value: item.destination_store_id }));
        dates  = dates.map((d) => new Date(d))
        setDarkStores(dsData)
        setFetchedIds(fetched_dark_store_ids)
         // Set status based on the conditions
        if (fetched_dark_store_ids.length === 0) {
          setStatus("warning"); // No stores fetched
        } else if (fetched_dark_store_ids.length === dsData.length) {
          setStatus("successAllFetched"); // All stores fetched
        } else {
          setStatus("successPartialFetched"); // Some stores fetched
        }
        setHighlightedDates(dates)
      } else {
      }

    } catch (error) {
      const errorMessage = error.response?.data?.message || "Failed to getting DS Filters";
      console.log({ errorMessage })
    }

  }


  const getMainData = async () => {
    await getDsFiltersData()
    await getDarkStoreData()
  }
  
  useEffect(() => {
    getMainData()
  }, []);

  const handleApplyFilter = async () => {
    if (!selectedStore || !currentinvoiceDate) {
      alert("Please select both DS and Date to filter.");
      return;
    }

    const params = {
      date: currentinvoiceDate,
      store: selectedStore?.value || ""
    };

    try {
      setLoadshow("show-m");
      setOverlayBlock("show-m");

      const response = await redirectURL.post(
        "inventory/getDarkStoresDataByDateAndStore",
        params
      );

      setLoadshow("show-n");
      setOverlayBlock("show-n");

      const resData = response.data;

      if (resData.status === "success") {
        setDarkStoreData(resData.data);
        setCurrentInvoiceDate(new Date(resData.date));
      } else if (resData.status === "info") {
        setShow(true);
        setBasicType("info");
        setBasicTitle(resData.message || "No data found for the selected filters.");
        setDarkStoreData([]);
      }
    } catch (error) {
      const errorMessage = error.response?.data?.message || "Failed to fetch data.";
      setShow(true);
      setBasicType("error");
      setBasicTitle(errorMessage);
      setLoadshow("show-n");
      setOverlayBlock("show-n");
    }
  };
  const onClickUploadSkuMasterData = (event) => {
    setSliderOpen(true);
    setSliderType(1);
    setSliderCl("slider-25");
    setSliderTitle("Upload Dark Store Data");
    setOverlyBlock("show-m");
  };

    const onClickFetchData = (event) => {
    setSliderOpen(true);
    setSliderType(2);
    setSliderCl("slider-25");
    setSliderTitle("Fetch Dark Store Data");
    setSelectedDs(null)
    setOverlyBlock("show-m");
    
  };

  // Function To Trigger User Action
  const triggerUserAction = (trigerdata) => {
    redirectURL.post('inventory/triggerUserAction', trigerdata)
  }

  const onClickingSliderCloseIcon = () => {
    setOverlyBlock("show-n");
    setSliderOpen(false);
    if (document.getElementById("bulkUploadFile")) {
      document.getElementById("bulkUploadFile").value = "";
    }
    setUploadedFileData([]);
  };

  const checkDataWithDateAndDarkStore = async () => {
    try {
      const response = await redirectURL.post(
        "inventory/checkDarkStoreDataByDateAndStore",
        {
          date: currentDate,
          store: selectedDs?.value || ""
        }
      );
      
      return response?.data?.status === "success"
        ? response.data.exists
        : false;

    } catch (err) {
      console.error("Error checking data:", err);
      return false; // always return boolean
    }
  };

  const checkTriggerStatus = async () => {
    try {
        const response = await redirectURL.post("inventory/checkIsTriggerDone", { trigger_date: currentDate });
        return response?.data?.status === "success"
          ? response.data.exists
          : false;

      } catch (err) {
        console.error("Error checking data:", err);
        return false; // always return boolean
      }
  }

  const handleDataUpload = async (upload_type) => {
    const params = { 
      date: currentDate, 
      dark_store_id: selectedDs?.value || "", 
      dark_store_name: selectedDs?.label || "", 
      masterData: uploadedFileData, 
      filename ,
      upload_type
    };

      // console.log("Uploading with params:", params);

    try {
      setLoadshow("show-m");
      setOverlayBlock("show-m");

      const response = await redirectURL.post("inventory/storeDarkStoreData", params);

        if (response.data.status === "success") {
          await getDarkStoreData();
          setLoadshow("show-n");
          setOverlayBlock("show-n");
          setShow(true);
          setBasicType("success");
          setBasicTitle("Data Uploaded Successfully");

          // User Action Triggering Starts Here
          var userData = {
            email: localStorage.getItem("email"),
            user_code: localStorage.getItem("user_code"),
            action: "Uploaded Dark Stores Data",
            status: "Success",
            path: window.location.pathname
          }
          triggerUserAction(userData)
          // User Action Triggering Ends Here

        } else {
          setLoadshow("show-n");
          setOverlayBlock("show-n");
          setShow(true);
          setBasicType("info");
          setBasicTitle("Data Upload Failed");

          // User Action Triggering Starts Here
          var userData = {
            email: localStorage.getItem("email"),
            user_code: localStorage.getItem("user_code"),
            ction: "Uploaded Dark Stores Data",
            status: "Failure",
            path: window.location.pathname
          }
          triggerUserAction(userData)
          // User Action Triggering Ends Here
        }

      } catch (error) {
        const errorMessage = error.response?.data?.message || "Failed to upload data";
        setShow(true);
        setBasicType("info");
        setBasicTitle(errorMessage);
        setLoadshow("show-n");
        setOverlayBlock("show-n");
        // User Action Triggering Starts Here
        var userData = {
          email: localStorage.getItem("email"),
          user_code: localStorage.getItem("user_code"),
          action: "Uploaded Dark Stores Data",
          status: "Failure",
          path: window.location.pathname
        }
        triggerUserAction(userData)
        // User Action Triggering Ends Here
      }
    };

//   const handleFetchData = async () => {
//   if ( !currentDate) {
//     setShow(true);
//     setBasicType("info");
//     setBasicTitle("Please select both DS Store and Date to fetch data.");
//     return;
//   }

//   const params = {
//     trigger_date: currentDate,
//   };
//   console.log(params)

//   try {
//     setLoadshow("show-m");
//     setOverlayBlock("show-m");

//     const response = await redirectURL.post("inventory/DarkStoreUnicomStock", params);

//     if (response.data.status === "success") {
//       await getMainData()
//       setLoadshow("show-n");
//       setOverlayBlock("show-n");
//       setShow(true);
//       setBasicType("success");
//       setBasicTitle(response.data.message);
//       var userData = {
//       email: localStorage.getItem("email"),
//       user_code: localStorage.getItem("user_code"),
//       action: "Fetched Dark Stores Data",
//       status: "Success",
//       path: window.location.pathname
//     }
//     triggerUserAction(userData)
//     } else {
//       setLoadshow("show-n");
//       setOverlayBlock("show-n");
//       setShow(true);
//       setBasicType("info");
//       setBasicTitle("No data found for the selected filters.");
//         var userData = {
//       email: localStorage.getItem("email"),
//       user_code: localStorage.getItem("user_code"),
//       action: "Fetched Dark Stores Data",
//       status: "Failure",
//       path: window.location.pathname
//     }
//     triggerUserAction(userData)
//     }
//   } catch (error) {
//     const errorMessage = error.response?.data?.message || "Failed to fetch data.";
//     setLoadshow("show-n");
//     setOverlayBlock("show-n");

//     setShow(true);
//     setBasicType("error");
//     setBasicTitle(errorMessage);
//   }
// };
   const handleFetchData = async () => {
  if (!currentDate) {
    setShow(true);
    setBasicType("info");
    setBasicTitle("Please select Date to fetch data.");
    return;
  }

  const params = {
    trigger_date: currentDate
  };

  try {
    setLoadshow("show-m");
    setOverlayBlock("show-m");

    const response = await redirectURL.post(
      "inventory/DarkStoreUnicomStock",
      params
    );

    const res = response?.data?.pyResponse;

    if (res.status == "Success"){
        setLoadshow("show-n");
        setOverlayBlock("show-n");
        setShow(true);
        setBasicType("success");
        setBasicTitle(res.message);
        await getMainData();

        //  user action audit
        triggerUserAction({
            email: localStorage.getItem("email"),
            user_code: localStorage.getItem("user_code"),
            action: "Fetched Dark Store Data",
            status: res.status,
            path: window.location.pathname
        });
    }
    else{
        setLoadshow("show-n");
        setOverlayBlock("show-n");
        setShow(true);
        setBasicType("info");
        setBasicTitle(res.message);
        await getMainData();

        //  user action audit
        // triggerUserAction({
        //     email: localStorage.getItem("email"),
        //     user_code: localStorage.getItem("user_code"),
        //     action: "Fetched Dark Store Data",
        //     status: res.status,
        //     path: window.location.pathname
        // });
    }

  } catch (error) {
    setLoadshow("show-n");
    setOverlayBlock("show-n");

    setShow(true);
    setBasicType("error");
    setBasicTitle(
      error?.response?.data?.message || "Failed to fetch dark store data."
    );

    triggerUserAction({
      email: localStorage.getItem("email"),
      user_code: localStorage.getItem("user_code"),
      action: "Fetched Dark Store Data",
      status: "Error",
      path: window.location.pathname
    });
  }
};

  const onClickingFileSubmit = async () => {

    if (uploadedFileData.length === 0) {
      setShow(true);
      setBasicType("info");
      setBasicTitle("Please upload a file");
      return;
    }

    const firstWord = selectedDs?.label?.split(" ")[0]?.toLowerCase();
    const containsWord = filename.toLowerCase().includes(firstWord);
    
    if (!containsWord) {
      setShow(true);
      setBasicType("info");
      setBasicTitle("Please upload a file with the correct name that matches the Dark Store name.");
      return;
    }

    const isTriggered = await checkTriggerStatus();
    if (isTriggered) {
      setShow(true);
      setBasicType("info");
      setBasicTitle("To Re Upload File, Kindly Revoke Trigger Inventory");
      return;
    }

    const data_exists = await checkDataWithDateAndDarkStore();

    if (data_exists) {
      setConfirmPopup(data_exists);
      return;
    }

    // If no existing data, upload directly
    handleDataUpload("new_upload");
  };


  const darkStoreColumnDefs = [
    { headerName: "SKU Code", field: "sku_code", pinned: "left", width: "180" },
    { headerName: "SKU Name", field: "item_name" },
    { headerName: "Shelf", field: "shelf" },
    { headerName: "Batch Status", field: "batchstatus" },
    { headerName: "Type", field: "type" },
    { headerName: "Total Stock", field: "total_stock_on_hand" },
    { headerName: "Available (ATP)", field: "available_atp" },
    { headerName: "Blocked", field: "blocked_committed" },
    { headerName: "Not Found", field: "not_found" },
    { headerName: "Inventory Allocation", field: "inventory_allocation" },
    { headerName: "Inventory Sync", field: "inventory_sync" },
    { headerName: "Sku Mixing", field: "sku_mixing" },
    { headerName: "Shelf on Hold", field: "shelf_on_hold" },
    { headerName: "Pendency", field: "pendency_on_all_channels" },
    { headerName: "Total Inventory", field: "total_inventory" },
    { headerName: "Inventory ID", field: "item_type_inventory_id" },
    { headerName: "Dark Store", field: "dark_store_name" },
    // { headerName: "Store ID", field: "dark_store_id" },
    {
      headerName: "Updated On",
      field: "updated",
      valueFormatter: (params) => {
        if (!params.value) return "";
        const date = new Date(params.value);
        return date.toISOString().slice(0, 10); // YYYY-MM-DD
      },
      hide: true
    },

    { headerName: "File Name", field: "filename", hide: true },
  ];


  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setFile(e.target.value)
    const filename = file.name;
    setFilename(filename)
    const reader = new FileReader();
    reader.onload = (event) => {
      const data = new Uint8Array(event.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
      const parsedData = XLSX.utils.sheet_to_json(worksheet, {
        raw: false,
        dateNF: "yyyy-mm-dd",
      });

      function toSnakeCase(str) {
        return str
          .trim()
          .replace(/\s+/g, '_')           // replace spaces with underscores
          .replace(/[A-Z]/g, letter => letter.toLowerCase()) // lowercase any capitals
          .replace(/[^a-z0-9_]/g, '')     // remove any special chars if needed
      }

      const result = parsedData.map(item => {
        const newItem = {};
        for (const key in item) {
          // if (mapping[key]) {
          //     // if in mapping use mapped version
          //     newItem[mapping[key]] = item[key];
          // } else {
          // if not in mapping, convert key to snake_case
          newItem[toSnakeCase(key)] = item[key];
          // }
        }
        return newItem;
      });


      console.log("Parsed Data:", result);
      setUploadedFileData(result);
    };
    reader.readAsArrayBuffer(file);
  };

  const hideOverlySlideBlock = () => {
    setOverlyBlock("show-n");
    setLoadshow("show-n");
    setSliderOpen(false);
    if (document.getElementById("bulkUploadFile")) {
      document.getElementById("bulkUploadFile").value = "";
    }
    setCurrentUploadedDate("")
    setUploadedFileData([]);
  };


  const downloadExcelTemplate = async () => {
    try {
      const response = await fetch(dsStorescsv);
      const csvText = await response.text();
      const rows = csvText
        .trim()
        .split("\n")
        .map(line => line.split(","));

      const ws = utils.aoa_to_sheet(rows);
      const wb = utils.book_new();
      utils.book_append_sheet(wb, ws, "Sheet1");

      writeFile(wb, "sample_darkstore_template.xlsx");
    } catch (error) {
      console.error("Error downloading or parsing CSV:", error);
    }
  };

  const closeAlert = () => {
    const fileInput = document.getElementById("bulkUploadFile");
    if (fileInput !== null) {  // Check if the element exists
      fileInput.value = "";  // Clears the input if element exists
    }

    setUploadedFileData([]);
    setShow(false);
    setLoadshow("show-n");
    setOverlayBlock("show-n");
    setOverlyBlock("show-n");
    setSliderOpen(false)
    setCurrentUploadedDate("")

  };


  const sideBar = useMemo(() => ({
    toolPanels: [
      {
        id: "columns",
        labelDefault: "Columns",
        labelKey: "columns",
        iconKey: "columns",
        toolPanel: "agColumnsToolPanel",
      },
      {
        id: "filters",
        labelDefault: "Filters",
        labelKey: "filters",
        iconKey: "filter",
        toolPanel: "agFiltersToolPanel",
      },
    ]
  }), []);

  const statusPanel = {
    statusPanels: [
      {
        statusPanel: "agTotalAndFilteredRowCountComponent",
        align: "left"
      },
      {
        statusPanel: "agTotalRowCountComponent",
        align: "center"
      },
      { statusPanel: "agFilteredRowCountComponent" },
      { statusPanel: "agSelectedRowCountComponent" },
      { statusPanel: "agAggregationComponent" }
    ]
  }

  const renderStatus = () => {
    const labelMap = darkStores.reduce((acc, store) => {
      acc[store.value] = store.label; // Assuming dsStores has 'value' and 'label' keys
      return acc;
    }, {});

    const fetchedLabels = fetchedIds.map(id => labelMap[id] || id); // Replace ID with label if exists

    switch (status) {
      case "loading":
        return (
          <div style={statusStyles.loading}>
            <p>Status: LOADING</p>
          </div>
        );
      case "warning":
        return (
          <div style={statusStyles.warning}>
            <p>Status: WARNING</p>
            <p><b>No Dark Store is Fetched Yet:</b></p>
          </div>
        );
      case "successAllFetched":
        return (
          <div style={statusStyles.success}>
            <p>Status: SUCCESS</p>
            <p><b>All Stores Fetched:</b> No more stores are left to fetch.</p>
          </div>
        );
      case "successPartialFetched":
        return (
          <div style={statusStyles.success}>
            <p>Status: SUCCESS</p>
            <p><b>Fetched Stores:</b> {fetchedLabels.join(", ")}</p>
          </div>
        );
      case "error":
        return (
          <div style={statusStyles.error}>
            <p>Status: ERROR</p>
            <p>Failed to fetch Stores</p>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div className="container-fluid mt-3">
       <div style={{ zIndex: "9999999" }}>
        <SweetAlert
            show={show}
            type={basicType}
            title={basicTitle}
            onConfirm={closeAlert}
            style={{ fontSize: "9px" }}
        >
        </SweetAlert>
    </div>


      <div className="row mt-3">
        <form
          className="col-sm-12 p-0 mt-4 mb-4"
          style={{
            display: "flex",
            alignItems: "center",
            flexWrap: "nowrap",
            gap: "20px",
            justifyContent: "space-between"
          }}
        >
          {/* Left Filters + Buttons + Upload */}
          <div style={{ display: "flex", alignItems: "center", gap: "16px", flex: "1" }}>
            {/* DS Store */}
            <div>
              <label htmlFor="storeId" style={{ fontSize: '13px', fontWeight: '400' }}>
                Select DS Store:
              </label>
              <Select
                id="storeId"
                options={darkStores}
                value={selectedStore}
                onChange={(option) => setSelectedStore(option)}
                placeholder="Choose DS"
                styles={selectStyles}
              />
            </div>

            <div style={{ display: "flex", flexDirection: "column"  }}>
            <label style={{ fontSize: "13px", fontWeight: "400" }}>Uploaded Date:</label>
             <DatePicker
                selected={new Date(currentinvoiceDate)}
                onChange={(date) => {
                  setPrevDate(new Date(currentinvoiceDate));
                  setCurrentInvoiceDate(date);
                }}
                dateFormat="yyyy-MM-dd"
                className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                wrapperClassName="w-full"
                highlightDates={[
                  {
                    "react-datepicker__day--highlighted-custom": highlightedDates,
                  },
                ]}
              />
            </div>

            {/* Apply / Reset */}
            <div style={{ display: "flex", gap: "10px", marginTop: '30px' }}>
              <button
                type="button"
                onClick={(e) => { e.preventDefault(); handleApplyFilter(); }}
                style={{
                  height : "40px",
                  backgroundColor: "#93385D",
                  color: "#fff",
                  borderRadius: "5px",
                  padding: "7px 20px",
                  border: "none",
                  cursor: "pointer",
                  marginTop: "1px"
                }}
              
              >Apply</button>

              <button
                onClick={(e) => { e.preventDefault(); getDarkStoreData(); }}
                type="button"
                style={{
                  backgroundColor: "#fff",
                  color: "#000",
                  borderRadius: "5px",
                  padding: "8px 20px",
                  border: "1px solid #d9d9d9",
                  cursor: "pointer"
                }}
              >Reset</button>


          <button
            onClick={(e) => { e.preventDefault(); onClickFetchData(); }}
              className="add-button upload-add-button fetch-stn"
            >
              <MdSync style={{ color: "#93385D", fontSize: "18px" }} />
              <span style={{ marginLeft: "6px" }}>Fetch Darkstore Data</span>
            </button>


             <button
            onClick={(e) => { e.preventDefault(); onClickUploadSkuMasterData(); }}
              className="add-button upload-add-button "
            >
              <MdOutlineFileUpload style={{ color: "#93385D", fontSize: "18px" }} />
              <span style={{ marginLeft: "10px" }}>Upload</span>
            </button>


          </div>
            </div>


          {/* Counters Box */}
          <div style={{
            backgroundColor: "#fff",
            borderRadius: "10px",
            padding: "16px 24px",
            border: "1px solid #e3b7ce",
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.05)",
            minWidth: "250px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            gap: "12px"
          }}>
            {/* Total SKUs */}
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <span style={{ fontSize: "14px", fontWeight: 600, color: "#93385D" }}>Total SKUs</span>
              <span style={{
                fontSize: "20px",
                fontWeight: "bold",
                color: "#93385D",
                backgroundColor: "#fbeff4",
                borderRadius: "6px",
                padding: "4px 12px",
                minWidth: "50px",
                textAlign: "center"
              }}>
                {darkStoreData?.length || 0}
              </span>
            </div>

            {/* Available ATP */}
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <span style={{ fontSize: "14px", fontWeight: 600, color: "#93385D" }}>Available ATP</span>
              <span style={{
                fontSize: "20px",
                fontWeight: "bold",
                color: "#93385D",
                backgroundColor: "#fbeff4",
                borderRadius: "6px",
                padding: "4px 12px",
                minWidth: "60px",
                textAlign: "center"
              }}>
                {
                  darkStoreData?.reduce?.((sum, row) => {
                    const atpKey = Object.keys(row || {}).find(
                      k => k.toLowerCase() === "atp" || k.toLowerCase() === "available_atp"
                    );
                    const val = atpKey ? Number(row[atpKey]) : 0;
                    return sum + (isNaN(val) ? 0 : val);
                  }, 0) || 0
                }
              </span>
            </div>
          </div>
        </form>
      </div>




      <div className="ag-theme-alpine " style={{ height: 500, width: "100%" }}>
        <AgGridReact
          rowData={darkStoreData}
          columnDefs={darkStoreColumnDefs}
          defaultColDef={{ resizable: true, sortable: true, filter: true }}
          domLayout="normal"
          suppressHorizontalScroll={false} // allow scroll
          sideBar={sideBar}
          statusBar={statusPanel}
          pagination={true}
          paginationPageSize={100}
          enableRangeSelection={true}
          gridOptions={{
            suppressHorizontalScroll: false
          }}
        />
      </div>
      <div
        className={`stock-status-slider ${isSliderOpen ? "open" : ""} ${sliderCl}`}
        style={{ width: "25%" }}
      >
        <div className="slider-header-container d-flex justify-content-between">
          <p className="m-0p">{sliderTitle}</p>
          <p
            className="m-0p"
            style={{ cursor: "pointer" }}
            onClick={onClickingSliderCloseIcon}
          >
            X&nbsp;&nbsp;&nbsp;
          </p>

        </div>

        {sliderType === 1 && (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              height: "100%",
              overflowY: "auto",
              padding: 5,
            }}
          >
            <form style={{ flexGrow: 1, overflowY: "auto", padding: "10px" }}
              onSubmit={(e) => { e.preventDefault(); onClickingFileSubmit() }}
            >
              <div className="d-flex justify-content-end mb-10p">
                <div>
                  <button id="sample-download-button" onClick={downloadExcelTemplate}>
                    Download Sample Template (.xlsx)
                  </button>
                </div>
              </div>
              <div className="mt-2">
                <label htmlFor="store" style={{ fontSize: '13px', fontWeight: '400' }}>
                  Select DS Store:
                </label>
                <Select
                  id="store"
                  options={darkStores}
                  value={selectedDs}
                  onChange={(option) => setSelectedDs(option)}
                  placeholder="Choose DS"
                  styles={selectStyles}
                />
              </div>
              <div className="mb-1 mt-4" style={{ display: "flex", flexDirection: "column" }}>
                <label
                  style={{ fontSize: "13px", fontWeight: "400" }}
                >
                  Date:
                </label>
                <input
                  // type="date"
                  id="uploadDate"
                  value={currentDate}
      
                  style={{
                    padding: "7px",
                    borderRadius: "5px",
                    border: "1px solid #d9d9d9",
                    width: "100%",
                    marginBottom: "15px",
                    cursor: "default",
                    backgroundColor: "#f9f9f9",
                  }}
                />

              </div>

              <input
                className="mt-3"
                type="file"
                accept=".csv,.xlsx,.xls"
                onChange={handleFileChange}
                style={{
                  border: "1px solid lightgrey",
                  width: "100%",
                  padding: "8px",
                  borderRadius: "5px",
                  backgroundColor: "#f9f9f9",
                  color: "#000",
                  fontSize: "13px",
                }}
                id="bulkUploadFile"
                required
              />
              <p
                style={{
                  color: "red",
                  fontSize: "13px",
                  margin: "0px",
                  marginTop: "10px",
                }}
              >
                *Accept .csv & .xlsx files only
              </p>

              <div style={{ textAlign: "right", marginTop: "10px" }}>
                <button
                  className="btn btn-success"
                  style={{
                    color: "#fff",
                    fontSize: "0.8rem",
                    backgroundColor: "#93385D"
                  }}
                  type="submit"

                >
                  {"Submit"}
                </button>
              </div>
            </form>
          </div>
        )}
      {sliderType === 2 && (
  <div style={{ padding: "10px" }}>
    <div className="mb-3">
      <label style={{ fontSize: "13px", fontWeight: "400" }}>Date:</label>
      <input
        disabled
        value={currentDate}
        style={{
          padding: "7px",
          borderRadius: "5px",
          border: "1px solid #d9d9d9",
          width: "100%",
          backgroundColor: "#f9f9f9",
        }}
      />
    </div>

    {renderStatus()}

    <div style={{ textAlign: "right", marginTop: "10px" }}>
      <button
        className="btn btn-success"
        style={{
          color: "#fff",
          fontSize: "0.8rem",
          backgroundColor: "#93385D"
        }}
        onClick={(e) => {
          e.preventDefault();
          handleFetchData();
        }}
      >
        Fetch Data
      </button>
    </div>
  </div>
)}

      </div>

      {confirmPopup && (
            <div className="popup-overlay">
              <div className="popup-box">
                <h3>Data already exists</h3>
                {/* <p>Uploading will overwrite the existing data. Do you want to continue?</p> */}
                 <p style={{ marginBottom: "20px", fontSize: "14px", color: "#555" }}>
                    Data for <b>{currentDate}</b> and <b>{selectedDs.label}</b> already exists.
                      
                    Do you want to Re Upload the data ?
                  </p>
                <div className="popup-actions">
                  <button
                    onClick={() => {
                      setConfirmPopup(false);
                      handleDataUpload("re_upload");
                    }}
                    className="yes-btn"
                  >
                    Yes
                  </button>
                  <button
                    onClick={() => setConfirmPopup(false)}
                    className="no-btn"
                  >
                    No
                  </button>
                </div>
              </div>
            </div>
      )}

    <div className={`loader ${loadshow}`} style={{ zIndex: "1002" }}></div>
    <div className={`overlay-block ${overlayBlock}`}></div>
    <div className={"overly-block " + overlyBlock} onClick={hideOverlySlideBlock}></div>

    </div>
  );
};

  const statusStyles = {
    loading: {
      border: "1px solid orange",
      backgroundColor: "#fff4e5",
      color: "orange",
      padding: "12px",
      borderRadius: "8px",
      marginTop: "12px",
      fontSize: "14px",
      lineHeight: "20px",
    },
    warning: {
      border: "1px solid orange",
      backgroundColor: "#fff4e5",
      color: "orange",
      padding: "12px",
      borderRadius: "8px",
      marginTop: "12px",
      fontSize: "14px",
      lineHeight: "20px",
    },
    success: {
      border: "1px solid green",
      backgroundColor: "#e6ffed",
      color: "green",
      padding: "12px",
      borderRadius: "8px",
      marginTop: "12px",
      fontSize: "14px",
      lineHeight: "20px",
    },
    error: {
      border: "1px solid red",
      backgroundColor: "#fdd",
      color: "red",
      padding: "12px",
      borderRadius: "8px",
      marginTop: "12px",
      fontSize: "14px",
      lineHeight: "20px",
    }
  };

const selectStyles = {
  control: (base) => ({
    ...base,
    padding: '1px',
    borderRadius: '5px',
    border: '1px solid #d9d9d9',
  }),
  singleValue: (base) => ({
    ...base,
    fontWeight: 'normal',   // <-- make the text not bold
    color: '#333',
    fontSize: "12px"         // optional: adjust color
  }),
  option: (base, state) => ({
    ...base,
    fontSize: "13px",
    fontWeight: state.isSelected ? 'normal' : 'normal', // make options also normal if you wish
  })
}


export default DarkStoresTab;